import React from 'react'

const Loading = () => {

    return (

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
            <div className="spinner"></div>
        </div>

    )
}

export default Loading